import * as React from "react";
const IconLa = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h513v342H0z" />
    <path  d="M0 .1h513v90.7H0zm0 251.2h513V342H0z" />
    <circle cx={256.5} cy={171} r={65.9}  />
  </svg>
);
export default IconLa;
